
export default function __vue_create_injector__() {
  const styles = __vue_create_injector__.styles ||= new Set();
  return function addStyle({ id, css, media, filename }) {
    if (styles.has(id)) return;
    if (!__vue_create_injector__.element) {
      const element = document.createElement('style');
      document.head.appendChild(element);
      __vue_create_injector__.element = element;
    }
    let code = css;
    if (media) code = '@media ' + media + ' {\n' + code + '\n}';
    __vue_create_injector__.element.appendChild(document.createTextNode('\n/* ' + filename + ' */\n' + code + '\n'));
    styles.add(id);
  };
}